// // src/config.js
// const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'https://moneyzone.online';
// const APP_ORIGIN = process.env.REACT_APP_APP_ORIGIN || 'http://localhost:3000';

// const config = {
//   API_ORIGIN,
//   APP_ORIGIN,
//   // Legacy — phased out endpoint by endpoint
//   API_BASE_URL: `${API_ORIGIN}/api_rfs_temp.php?table=`,
//   // Secured app API
//   API_APP_BASE_URL: `${API_ORIGIN}/api_app.php?table=`,
//   MEDIATOR_APP_URL: `${API_ORIGIN}/mediator_app.php`,
//   APP_BASE_URL: `${API_ORIGIN}/`,
// };

// export function buildCspConnectSrc() {
//   const origins = new Set([
//     "'self'",
//     API_ORIGIN,
//     APP_ORIGIN,
//     process.env.REACT_APP_WS_ZERODHA_URL || '',
//     process.env.REACT_APP_WS_GLOBAL_URL || '',
//     process.env.REACT_APP_ALT_FEED_WS_URL || '',
//   ]);
//   return Array.from(origins).filter(Boolean).join(' ');
// }

// export default config;
// src/config.js
const ENV_API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'https://moneyzone.online';
const ENV_APP_ORIGIN = process.env.REACT_APP_APP_ORIGIN || 'http://localhost:3000';

function isIpHostname(hostname) {
  if (!hostname) {
    return false;
  }
  if (/^(?:\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    return true;
  }
  return hostname.includes(':');
}

function resolveApiOrigin() {
  if (typeof window !== 'undefined' && isIpHostname(window.location.hostname)) {
    return window.location.origin;
  }
  return ENV_API_ORIGIN;
}

function getApiOrigin() {
  return resolveApiOrigin();
}

const config = {
  get API_ORIGIN() {
    return getApiOrigin();
  },
  APP_ORIGIN: ENV_APP_ORIGIN,
  get API_BASE_URL() {
    return `${getApiOrigin()}/api_rfs_temp.php?table=`;
  },
  get API_APP_BASE_URL() {
    return `${getApiOrigin()}/api_app.php?table=`;
  },
  get MEDIATOR_APP_URL() {
    return `${getApiOrigin()}/mediator_app.php`;
  },
  get APP_BASE_URL() {
    return `${getApiOrigin()}/`;
  },
};

export function buildCspConnectSrc() {
  const origins = new Set([
    "'self'",
    getApiOrigin(),
    ENV_APP_ORIGIN,
    process.env.REACT_APP_WS_ZERODHA_URL || '',
    process.env.REACT_APP_WS_GLOBAL_URL || '',
    process.env.REACT_APP_ALT_FEED_WS_URL || '',
  ]);
  return Array.from(origins).filter(Boolean).join(' ');
}

export default config;
